import React from 'react'

const RawProdect = () => {
  return (
    <div>
      RawProdect
    </div>
  )
}

export default RawProdect
